export enum enumBatchImportStatus {
  STARTED,
  FAILED,
  PARTIALLY_FINISHED,
  FINISHED,
  REVIEWED,
  FINISHED_WITHOUT_SOME_FILES,
}
